export const getNextTab = (currentTab, tabs) =>
  tabs?.find((t) => t.value === currentTab)?.nextTab;

export const getInitTab = (tabs) => tabs?.find((t) => t.isInitial)?.value || '';

export const getLastTabWithSubmit = (tabs) =>
  tabs?.find((t, index) => index === tabs?.length - 1 && !t?.hideSaveButton);
